import { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Input, Select, Popover, Button, Space } from "antd";
import styles from "./index.module.scss";

const { Option } = Select;

const AddGroupPopover = ({ popoverUngroupedAccounts, selectedAccounts, onUpdateSelectedAccounts, onConfirmAddGroup }) => {
  const [newGroupName, setNewGroupName] = useState(undefined);
  const [showPopover, setShowPopover] = useState(false);
  const onChangeNewGroupName = (e) => setNewGroupName(e.target.value);
  const onClosePopover = () => setShowPopover(false);
  const onAddNewGroup = () => {
    onConfirmAddGroup(newGroupName);
    setShowPopover(false);
  };
  const onToggleShowPopover = () => setShowPopover(!showPopover);

  const popOverTitle = (
    <div className={styles.editTitle}>
      <div>Add New Group</div>
    </div>
  );
  const addGroupPopOverContent = () => {
    return (
      <>
        <Input
          placeholder="Group name"
          style={{ width: 320, display: "block", marginBottom: 20 }}
          value={newGroupName}
          onChange={onChangeNewGroupName}
        />
        <Select
          mode="multiple"
          allowClear
          style={{ width: 320 }}
          placeholder="Select Account"
          value={selectedAccounts}
          onChange={onUpdateSelectedAccounts}
        >
          {popoverUngroupedAccounts.map((account) => (
            <Option key={account}>{account}</Option>
          ))}
        </Select>
        <div className={styles.editGroupbtn}>
          <Space size={25}>
            <Button size="small" onClick={onClosePopover}>
              Cancel
            </Button>
            <Button size="small" type="primary" onClick={onAddNewGroup}>
              Confirm
            </Button>
          </Space>
        </div>
      </>
    );
  };

  return (
    <Popover placement="bottom" title={popOverTitle} open={showPopover} content={addGroupPopOverContent} onOpenChange={setShowPopover}>
      <div onClick={onToggleShowPopover}>
        <EditOutlined />
        Add group
      </div>
    </Popover>
  );
};

export default AddGroupPopover;
